<template>
  <div :class="$style.wrapper">
    <div> Time remaining: </div>
    <div :class="$style.countdown">
      <div>
        {{ hours > 0 ? hours : 0 }}
        <span> Hour </span>
      </div>
      <div>
        {{ minutes > 0 ? minutes : 0 }}
        <span> Minutes </span>
      </div>
      <div>
        {{ seconds > 0 ? seconds : 0 }}
        <span> Seconds </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'countdown',
  props: ['expire'],
  data: function () {
    return {
      duration: 0,
    }
  },
  computed: {
    hours () {
      return Math.trunc(this.duration / 60 / 60)
    },
    minutes () {
      return Math.trunc((this.duration / 60) % 60)
    },
    seconds () {
      return Math.trunc(this.duration % 60)
    },
  },
  methods: {
    createDuration () {
      this.duration = this.$moment(this.expire).diff(this.$moment(), 'second')
      setTimeout(() => {
        if ((this.hours <= 0 && this.minutes <= 0 && this.seconds <= 0) || this.duration < 0) {
          clearInterval()
        } else {
          this.createDuration()
        }
      }, 1000)
    },
  },
  mounted () {
    this.createDuration()
  },
}
</script>

<style lang="scss" module>
@import '@/components/Countdown/style.module.scss';
</style>
